import {useAuth} from "../../contexts/AuthProvider";
import {useEffect, useState} from "react";
import {db} from "../../firebase/firebase";
import {formatPhoneNumber} from "../GlobalFunctions";
import {TrashIcon} from "@heroicons/react/24/outline";
import {Button, Switch} from "@headlessui/react";
import {format} from "date-fns";
import { doc, updateDoc } from "firebase/firestore"; // ensure this import exists


const Messages = () => {

    const { currentUser } = useAuth();

    const [messages, setMessages] = useState([]);
    const lastUpdated = localStorage.getItem(`messages_last_updated_${currentUser.uid}`);


    useEffect(() => {
        const fetchMessages = async () => {
            if (currentUser) {
                try {
                    const storedMessageData = localStorage.getItem(`messages_${currentUser.uid}`);
                    if (storedMessageData) {
                        const messageData = JSON.parse(storedMessageData);
                        setMessages(messageData);
                    } else {
                        const messageCollectionRef = db.collection('Messages');
                        const snapshot = await messageCollectionRef.get();

                        if (!snapshot.empty) {
                            const messageData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                            setMessages(messageData);
                            localStorage.setItem(`messages_${currentUser.uid}`, JSON.stringify(messageData));
                        } else {
                            console.log('No messages found');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching chems:', error);
                }
            }
        };

        fetchMessages();

    }, [currentUser]);

    const onUpdate = async () => {
        const messageCollectionRef = db.collection('Messages');
        const snapshot = await messageCollectionRef.get();

        if (!snapshot.empty) {
            const messageData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setMessages(messageData);
            console.log("Updated Successfully");

            localStorage.setItem(`messages_${currentUser.uid}`, JSON.stringify(messageData));

            const now = new Date();
            const formatted = format(now, 'MMM dd, yyyy \'at\' hh:mm a');
            localStorage.setItem(`messages_last_updated_${currentUser.uid}`, formatted);


        } else {
            console.log('No messages found');
        }
    };

    const deleteMessage = async (id) => {
        try {
            await db.collection('Messages').doc(id).delete();

            await onUpdate();

            console.log(`Message with id ${id} deleted`);
        } catch (error) {
            console.error('Error deleting message:', error);
        }
    };

    const handleRespondedChange = async (messageId) => {
        try {
            const messageRef = doc(db, "Messages", messageId); // Adjust "Messages" to match your collection name
            await updateDoc(messageRef, { responded: true });
            console.log("Message marked as responded.");

            // Optionally update local state if needed
            setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                    msg.id === messageId ? { ...msg, responded: true } : msg
                )
            );

            await onUpdate();
        } catch (error) {
            console.error("Error updating responded status:", error);
        }
    };

    return (
        <div className={``}>
            <div className="p-4 animate-fadeIn bg-white shadow-lg h-dvh">

                {/*Header*/}
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-base font-semibold text-gray-900">Messages [{messages.length}]</h1>
                        <p className="mt-2 text-sm text-gray-700">
                            A list of all the incoming messages filled out on the website.
                            The last time this was updated was <span className={`font-semibold`}>{lastUpdated}</span>
                        </p>
                    </div>
                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                        <Button
                            onClick={onUpdate}
                            type="button"
                            className="block rounded-md bg-blue-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            Refresh
                        </Button>
                    </div>
                </div>

                {/*Table*/}
                <div className="mt-8 flow-root">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <table className="min-w-full divide-y divide-gray-300">
                                <thead>
                                <tr>
                                    <th
                                        scope="col"
                                        className="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-0"
                                    >
                                        Name
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                    >
                                        Phone
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                    >
                                        Email
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                    >
                                        Responded
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                    >
                                        Message
                                    </th>
                                    <th scope="col" className="relative py-3 pl-3 pr-4 sm:pr-0">
                                        <span className="sr-only">Edit</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                {messages.map((message) => (
                                    <tr key={message.id}>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                                            {message.fName + " " + message.lName}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{formatPhoneNumber(message.phone)}</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{message.email}</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 flex items-center justify-start">
                                            <Switch
                                                checked={message.responded}
                                                onChange={() => handleRespondedChange(message.id)}
                                                className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 data-[checked]:bg-blue-600"
                                            >
                                                <span className="sr-only">Use setting</span>
                                                <span className="pointer-events-none relative inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5">
                                                <span
                                                    aria-hidden="true"
                                                    className="absolute inset-0 flex size-full items-center justify-center transition-opacity duration-200 ease-in group-data-[checked]:opacity-0 group-data-[checked]:duration-100 group-data-[checked]:ease-out"
                                                >
                                                  <svg fill="none" viewBox="0 0 12 12" className="size-3 text-gray-400">
                                                    <path
                                                        d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                  </svg>
                                                </span>
                                                <span
                                                    aria-hidden="true"
                                                    className="absolute inset-0 flex size-full items-center justify-center opacity-0 transition-opacity duration-100 ease-out group-data-[checked]:opacity-100 group-data-[checked]:duration-200 group-data-[checked]:ease-in"
                                                >
                                                  <svg fill="currentColor" viewBox="0 0 12 12" className="size-3 text-blue-600">
                                                    <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                                                  </svg>
                                                </span>
                                              </span>
                                            </Switch>
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{message.message}</td>
                                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                                            <Button onClick={() => deleteMessage(message.id)} className="text-red-600 hover:text-red-500">
                                                <TrashIcon className={`size-5 hover:stroke-2 text-red-500`}/>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Messages;
